(() => {
  if (window.__vitalsMobileAccordionLoaded) return;
  window.__vitalsMobileAccordionLoaded = true;

  const mobileQuery = window.matchMedia('(max-width: 768px)');
  const containerSelector = '.vitals-tabs-container';

  function getParts(container) {
    const tabs = container.querySelector(':scope > .tabs');
    const links = tabs ? Array.from(tabs.querySelectorAll(':scope > .tab-link[data-tab]')) : [];
    return { tabs, links };
  }

  function getPanel(container, link) {
    const panelId = link.dataset.tab;
    return Array.from(container.querySelectorAll('.tab-content')).find(
      (panel) => panel.id === panelId
    );
  }

  function setOpen(container, selectedLink, shouldOpen) {
    const { links } = getParts(container);
    links.forEach((link) => {
      const panel = getPanel(container, link);
      const isOpen = shouldOpen && link === selectedLink;
      link.classList.toggle('mobile-open', isOpen);
      link.classList.toggle('current', isOpen);
      link.setAttribute('aria-expanded', String(isOpen));
      if (panel) {
        panel.classList.toggle('current', isOpen);
        panel.setAttribute('aria-hidden', String(!isOpen));
      }
    });
  }

  function applyMobileLayout(container) {
    const { tabs, links } = getParts(container);
    if (!tabs || !links.length) return;
    const isAlreadyMobile = container.classList.contains('vitals-mobile-accordion');
    container.classList.add('vitals-mobile-accordion');
    links.forEach((link) => {
      const panel = getPanel(container, link);
      link.setAttribute('role', 'button');
      link.setAttribute('tabindex', '0');
      if (panel && panel.parentElement !== link) link.appendChild(panel);
    });
    if (!isAlreadyMobile) {
      const initiallyOpen = links.find((link) => link.classList.contains('current')) || links[0];
      setOpen(container, initiallyOpen, true);
    }
  }

  function restoreDesktopLayout(container) {
    if (!container.classList.contains('vitals-mobile-accordion')) return;
    const { tabs, links } = getParts(container);
    if (!tabs || !links.length) return;
    const activeLink = links.find((link) => link.classList.contains('mobile-open')) || links[0];
    links.forEach((link) => {
      const panel = getPanel(container, link);
      const isActive = link === activeLink;
      link.classList.remove('mobile-open');
      link.classList.toggle('current', isActive);
      link.removeAttribute('role');
      link.removeAttribute('tabindex');
      link.removeAttribute('aria-expanded');
      if (panel) {
        container.appendChild(panel);
        panel.classList.toggle('current', isActive);
        panel.removeAttribute('aria-hidden');
      }
    });
    container.classList.remove('vitals-mobile-accordion');
  }

  function updateContainer(container) {
    if (mobileQuery.matches) applyMobileLayout(container);
    else restoreDesktopLayout(container);
  }

  function bindContainer(container) {
    const { tabs } = getParts(container);
    if (!tabs || container._vitalsMobileBoundTabs === tabs) return;
    container._vitalsMobileBoundTabs = tabs;
    tabs.addEventListener('click', (event) => {
      if (!mobileQuery.matches || event.target.closest('.tab-content')) return;
      const link = event.target.closest('.tab-link[data-tab]');
      if (!link || !tabs.contains(link)) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      setOpen(container, link, !link.classList.contains('mobile-open'));
    }, true);
    tabs.addEventListener('keydown', (event) => {
      if (!mobileQuery.matches || !['Enter', ' '].includes(event.key)) return;
      const link = event.target.closest('.tab-link[data-tab]');
      if (!link || !tabs.contains(link)) return;
      event.preventDefault();
      setOpen(container, link, !link.classList.contains('mobile-open'));
    }, true);
    updateContainer(container);
  }

  function initialize() {
    document.querySelectorAll(containerSelector).forEach(bindContainer);
    document.querySelectorAll(containerSelector).forEach(updateContainer);
  }

  let initializeQueued = false;

  function scheduleInitialize() {
    if (initializeQueued) return;
    initializeQueued = true;

    window.requestAnimationFrame(() => {
      initializeQueued = false;
      initialize();
    });
  }

  const observer = new MutationObserver(() => {
    scheduleInitialize();
  });

  function start() {
    initialize();
    if (document.body) {
      observer.observe(document.body, { childList: true, subtree: true });
    }

    // Vitals can rebuild its tabs after its own delayed app initialization.
    // Keep the mobile structure enforced without depending on mutation timing.
    window.setInterval(() => {
      if (mobileQuery.matches) initialize();
    }, 750);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }

  if (typeof mobileQuery.addEventListener === 'function') {
    mobileQuery.addEventListener('change', scheduleInitialize);
  } else {
    mobileQuery.addListener(scheduleInitialize);
  }
  document.addEventListener('shopify:section:load', scheduleInitialize);
  document.addEventListener('shopify:section:select', scheduleInitialize);
})();
